import React, { useCallback, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import EmailVerification, {
  VerifyEmailResponse,
} from "components/EmailVerification";
import { SLAPSHOT_LOGIN_URL } from "constants/urls";
import { getRedirectPath } from "utils/helper";

import styles from "./styles.module.scss";
import { AUTH_TOKEN, AUTH_USER } from "../../constants/constants";

const SlapshotVerifyEmailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, id } = location.state || {};

  useEffect(() => {
    if (!email || !id) {
      navigate(SLAPSHOT_LOGIN_URL);
    }
  }, [email, id, navigate]);

  const onVerified = useCallback(
    (res?: VerifyEmailResponse) => {
      if (res) {
        localStorage.setItem(AUTH_TOKEN, res.token);
        localStorage.setItem(AUTH_USER, JSON.stringify(res.data));
      }
      navigate(getRedirectPath(location));
    },
    [location, navigate],
  );

  if (!email || !id) {
    return null;
  }

  return (
    <div className={styles.container}>
      <EmailVerification email={email} userId={id} onVerified={onVerified} />
    </div>
  );
};

export default SlapshotVerifyEmailPage;
